function permissionsSettings () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/permissions-settings/permissions-settings-dialog.html?$$REVISION$$'
  }
}
export { permissionsSettings }
